import React from "react";

import hhLogo from "@content/img/job-market/hh-logo.svg";
import trudvsemLogo from "@content/img/job-market/trudvsem-logo.svg";

import styles from "./styles/jobMarket.module.css";

const LINKS = [
  {
    id: "trudvsem",
    title: "Работа России",
    description: "Государственный портал вакансий и уровень зарплат по профессиям",
    href: "https://trudvsem.ru/vacancy/search?_regionIds=0200000000000&salary=0%2C999999&scheduleType=FULL&vacancyType=LONG",
    icon: trudvsemLogo,
    iconAlt: "Работа России",
  },
  {
    id: "hh",
    title: "HeadHunter",
    description: "Вакансии и зарплаты в Уфе и Республике Башкортостан",
    href: "https://ufa.hh.ru/search/vacancy?text=&salary=&ored_clusters=true&area=1347&suggestId=27cefe82-bd08-4917-8267-21dd3bcb44ca&hhtmFrom=vacancy_search_list&hhtmFromLabel=vacancy_search_line",
    icon: hhLogo,
    iconAlt: "HeadHunter",
  },
];

function SalaryLinks() {
  return (
    <div className={styles.salaryLinks}>
      {LINKS.map((item) => (
        <a
          key={item.id}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.salaryLink}
        >
          <span className={styles.salaryLinkIcon}>
            <img src={item.icon} alt={item.iconAlt} />
          </span>
          <span className={styles.salaryLinkText}>
            <span className={styles.salaryLinkTitle}>{item.title}</span>
            <span className={styles.salaryLinkDesc}>{item.description}</span>
          </span>
          <span className={styles.salaryLinkArrow} aria-hidden="true" />
        </a>
      ))}
    </div>
  );
}

export default SalaryLinks;
